import { render, staticRenderFns } from "./lottie-web-cimo.vue?vue&type=template&id=d90e7af0&"
import script from "./lottie-web-cimo.vue?vue&type=script&lang=js&"
export * from "./lottie-web-cimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports